import React, { useState, useEffect } from 'react';
import { Container, Row, Col,Modal,Button } from 'react-bootstrap';
import './styles/App.css';
import { useHistory } from 'react-router';
import TopTitle from './TopTitle';
import queryString from 'query-string';
import { comma,instance } from './common';
import trash_img from './img/trash.png';
import check_on from './img/check_on.png';
import { formatDate,phoneFormat,currentDate } from './common';
import Pagination from "react-js-pagination";

import ksolution1 from './img/ksolution1.jpg';
import ksolution2 from './img/ksolution2.jpg';
import ksolution3 from './img/ksolution3.jpg';
import ksolution4 from './img/ksolution4.jpg';
import s1 from './img/sun_1.png';
import s2 from './img/sun_2.png';
import s3 from './img/sun_3.png';

import ray1 from './img/ray1.png';
import ray2 from './img/ray2.png';
import ray3 from './img/ray3.png';

function SigongModal({show,setShow,setName,setSeq,res}) {
  console.log('나오나')
    
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [si_area1, setArea1] = useState([]);
  const [si_area2, setArea2] = useState([]);

  const [si_area1Value, setArea1V] = useState('');
  const [si_area2Value, setArea2V] = useState('');

  const ppp = 10;
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [keyword ,setKeyword] = useState('');
  const [data, setData] = useState([]);
  const [s_name, setSname] = useState('인수점');
  const keywordChange = (e) => {
    setKeyword(e.target.value);
  }
  const onChange = (e) => {
    console.log('e.target : ', e.target)
    instance.post('/hy/sigong/si_area2',{si_area1:e.target.value}).then(function (res) {
      console.log('res : ', res.data)
      setPage(1);
      setArea1V(e.target.value)
      setArea2(res.data)
      
    });
  }

  const onChange2 = (e) => {
    setPage(1);
    setArea2V(e.target.value)
    
  }

  useEffect(() => {
    instance.post('/hy/sigong/si_area1').then(function (res) {
      console.log('여기도 안타지??')
      console.log('res : ', res.data)
      setArea1(res.data)
    });

    var like = new Object();

    console.log('res[0].type : ', res[0].type)
    like.field = 'si_show';
    if(res[0].cate === 'sun'){
       like.value = '썬가드';
       setSname('대리점')
    }else if(res[0].cate === 'k'){
        like.value = '현대';
    }
    

    if(si_area1Value){
     
        var common = new Object();
        common.si_area1 = si_area1Value;
        if(si_area2Value){
            common.si_area2 = si_area2Value;
        }
    }else{
        var common = '';
        console.log('위치체크')
    }

    const obj = {
        table:'sigong',
        page:page,
        ppp:ppp,
        like:like,
        keyword:keyword,
        common:common,
        order:'si_id'
    }

    instance.post('/hy/paging',obj).then(function (res) {
      console.log('res : ', res.data.sql)
        setData(res.data.rows)
        setTotal(res.data.totalCount);
    });

  },[page,keyword,si_area1Value,si_area2Value])

  const pageChange = (pageNumber) => {
      setPage(pageNumber);
  }

  const onClick = (e) => {
    setSeq(e.target.dataset.si_id)
    setName(e.target.dataset.si_name)
    handleClose();
  }

  console.log('total : ', total)
  return (
    <>
      <Modal show={show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>{s_name} 찾기</Modal.Title>
        </Modal.Header>
        <Modal.Body>
              <div className="clearfix mb-3">
                  <div className="float-left">
                  <select id="si_area1" className="p-0 select-css mr-1 form-control w-auto" onChange={onChange}>
                    <option value="">선택</option>
                    {
                      si_area1.map((v,i) => <option key={i} value={v.si_area1}>{v.si_area1}</option>)
                    }
                  </select>
                  <select id="si_area2" className="p-0 select-css form-control w-auto" onChange={onChange2}>
                    <option value="">-</option>
                    {
                      si_area2.map((v,i) => <option key={i} value={v.si_area2}>{v.si_area2}</option>)
                    }
                  </select>
                  </div>
                  <div className="clear mb-2"></div>
                  <input id="keyword" type="text" className="p-0 form-control d-inline-block w-100" value={keyword} onChange={keywordChange}/>
                  {/* <span className="float-right base-btn py-2 px-3">검색</span> */}
              </div>
              <table id="sigong-wrap" className="fs-11 sigong-table table table-bordered text-center">
                  <thead>
                      <tr>
                          <th>No(오름차순)</th>
                          <th>지역</th>
                          <th>{s_name}</th>
                          <th>연락처</th>
                          <th>선택</th>
                      </tr>
                  </thead>
                  <tbody id="sigong-tbody">
                    {
                      data.map((v,i) => <tr className="tr-sigong">
                      <td>{(((page -1) * ppp) + 1) + i}</td>
                      <td className="si_name">{v.si_area1} {v.si_area2}</td>
                      <td className="si_name">{v.si_name}</td>
                      <td>{phoneFormat(v.si_tel)}</td>
                      <td><input className="td-sigong-btn" data-si_id={v.si_id} data-si_name={v.si_name} type="checkbox" onClick={onClick}/></td>
                  </tr>)
                    }
                  </tbody>
              </table>

              <div className="text-center">
                  <Pagination
                      activePage={page}
                      itemsCountPerPage={10}
                      totalItemsCount={total}
                      pageRangeDisplayed={10}
                      onChange={pageChange}
                  />
              </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            닫기
          </Button>
          {/* <Button variant="primary" onClick={handleClose}>
            선택
          </Button> */}
        </Modal.Footer>
      </Modal>
    </>
  );
}

function totalPrice(data) {
  let price = 0;
  data.forEach(function (v) {
    price += Number(v.d_price);
  });
  return comma(price);
}

function totalPrice2(data) {
  let price = 0;
  data.forEach(function (v) {
    price += Number(v.total_price);
  });
  return comma(price);
}



function MakeBtn({data,sigongSeq,u_id}) {

  const session = JSON.parse(window.sessionStorage.result);
  const [s_name, setSname] = useState('인수점');

  useEffect(() => {
    if(data[0].cate == 'sun'){
      setSname('대리점')
    }
  },[])
  const GoPage = () => {
    if(sigongSeq === 0){
      alert(s_name+'을 입력해주세요.');
    }else{
      let dateStr = makeDateStr(data[0].cate)
      instance.post('/hy/reserve/k/count',{re_date:dateStr}).then(function (res) {
        console.log('asdad : ',res.data)
        const obj = {
          cate: data[0].cate,
          product : data[0].product,
          total_price : data[0].d_price,
          re_date : dateStr + '-' + res.data,
          car:data[0].car,
          u_seq : u_id,
          sigong_seq : sigongSeq,
          r_reserve_date : currentDate(),
        }

        instance.post('/common/insert',{table:'k_reserve',common:obj}).then(function (res) {
          window.location.replace('https://abys-service.co.kr/hyundai/kpayment.php?re_date='+obj.re_date+'&price='+obj.total_price+'&common='+JSON.stringify(obj))
        });
      });
  
  
      

    
  
      
  
      
    }
   
  }


  return (
    <span className="btn btn-primary r_btnsize" onClick={GoPage}>결제하기</span>
  )
}


function makeDateStr(cate){
  let first = '';
  if(cate == 'k'){
    first = 'K'
  }else if(cate == 'sun'){
    first = 'S'
  }
  return first + currentDate().replace(/-/gi, "");


}
function New_Cart({ setBannerType }) {
  const history = useHistory();
  let session = JSON.parse(window.sessionStorage.result);
  
  let { u_type, u_id } = session;
  const query = queryString.parse(history.location.search);
  console.log('query : ', query)
  const [data, setData] = useState(query.status === '00' ? [] : JSON.parse(query.data));
  
  const [show, setShow] = useState(false);
  const [sigongName, setName] = useState('');
  const [sigongSeq, setSeq] = useState(0);
  const [thum, setThum] = useState([]);


  let obj = {
    u_id: u_id,
  }

  const [dbData, setDB] = useState([
    {
        cate:'k',
        type:'유리막코팅',
        product	: '에슐론 NEO-G',
        s_price : 800000,
        d_price : 250000,
        img: ksolution1
    },
    {
        cate:'k',
        type:'가죽코팅',
        product	: '에슐론 Leather',
        s_price : 270000,
        d_price : 200000,
        img: ksolution2
    },
    {
        cate:'k',
        type:'실내클리닝',
        product	: '실내클리닝',
        s_price : 250000,
        d_price : 120000,
        img: ksolution3
    },
    {
        cate:'k',
        type:'광택',
        product	: '광택',
        s_price : 350000,
        d_price : 200000,
        img: ksolution4
    },
]);

const [s_name, setSname] = useState('인수점');

  useEffect(() => {
    console.log('useEffect 실행');
    
    setBannerType('')
    if(query.status === '00'){
      instance.post('/common/condition',{table:'k_reserve',common:{re_date:query.re_date}}).then(function (res) {
        console.log('res.data : ', res.data)
          instance.post('/common/condition',{table:'sigong',common:{si_id:res.data[0].sigong_seq}}).then(function (res) {
            setName(res.data[0].si_name)
          });
          setData(res.data)
          if(res.data[0].cate === 'k'){
            setThum(dbData.filter(v => v.product === res.data[0].product))
          }else{
            setSname('대리점')
            setThum([
              {
                cate:'sun',
                type:'s',
                product	: '에슐론 NEO-G',
                s_price : 0,
                d_price : 0,
                img: s1
            }
            ])
          }
          
          
          if(res.data[0].r_status === '예약완료'){
            instance.post('/common/update',{table:'k_reserve',common:{tid:query.tid,r_status:'결제완료'},field:'re_date',value:query.re_date}).then(function (res) {
              console.log('여기타나 : ', res)
            });
          }
      });
      
    }else{
      
      if(data[0].cate === 'k'){
      }else{
        setSname('대리점')
      }
    }
    
  }, []);

  const wordBreak = {
    wordBreak: 'keep-all'
  }
  const w60 = {
    width: '60%',
    verticalAlign: 'top'
  }
  const w30 = {
    width: '40%'
  }

  const moreCss = {
    width: '35px'
  }


  const bgSet = {
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    width: '25%',
    height: '200px',
    borderRadius: '5px',
    display: 'inline-block',
  }

  const ab = {
    position: 'absolute',
    right: '-4px',
    top: '14px',
    color: 'lightgray',
    fontSize: '10px'
  }
  const traswi = {
    width: '25px'
  }


  console.log('확인중 data : ', data)
  
  return (
    <>
      {
          show && <SigongModal res={data} setShow={setShow} show={show} setName={setName} setSeq={setSeq}/>
      }
      <Container className="mb-5">
        <div className="c_pad">
          {
            query.status === '00' 
            ?<TopTitle title="결제내역" />
            :<TopTitle title="결제" />
          }
          
          <div className="row p-0">
            {
              data.map((v,i) => <div className="col-12 pt-4 pb-3" key={i} style={{ position: 'relative',padding:'0'}}>
                <div>
                  {
                     query.status === '00' 
                     ? thum.map(vv => <img src={vv.img} className="mb-3" style={{width:'180px'}}/>)
                     : <img src={v.img}  className="mb-3" style={{width:'180px'}}/>
                    
                  }
                  
                  <div data-id={v.s_id} className="d-inline-block" style={{ ...wordBreak, verticalAlign: 'top' }}>
                    <h4 className="text-primary font-weight-bold" style={{ maxWidth: '600px' }}>{v.product}</h4>
                    <div style={{ marginTop: '30px' }}>
                      {
                         query.status === '00' 
                         ? 
                         <h4 className="font-weight-bold ml-3">결제금액 : {comma(v.total_price)}</h4>
                         : 
                         <>
                         <h5 className="font-weight-bold text-lightgray" style={{ textDecoration: 'line-through' }}>소비자가 : {comma(v.s_price)}</h5>
                         <h4 className="font-weight-bold">특별 할인가 : {comma(v.d_price)}</h4>
                         </>
                      }
                      
                    </div>
                  </div>
                </div>
              </div>)
            }

          </div>
          <div className="row mb-4 p-0" style={{ borderBottom: '2px solid black' }}>
            <h3 className="font-weight-bold mb-3">{s_name} 찾기</h3>
          </div>
          <input type="text" className="form-control mb-4" readOnly placeholder="클릭해주세요." onClick={() => setShow(true)} value={sigongName}/>
          <div className="row mb-4 p-0" style={{ borderBottom: '2px solid black' }}>
            <h3 className="font-weight-bold mb-3">금액정보</h3>
          </div>
          <div className="row p-0">
            <div className="col-4 pl-0">
              <span className="font-weight-bold d-block r_s_size">상품 총액</span>
            </div>
            <div className="col-8">
              <div className="mb-3 text-right">
                <span className="font-weight-bold" id="service_price">
                  {query.status === '00' ? totalPrice2(data) : totalPrice(data)}원
                </span>
              </div>
            </div>
          </div>
          <hr className="r_mg_top_none" />
          <div className="row r_mbdown p-0">
            <div className="col-3 pl-0">
              <span className="font-weight-bold d-block r_s_size r_nowrap">총 결제 금액</span>
            </div>
            <div className="col-9">
              <div className="r_r_color font-weight-bold text-right r_s_size" id="totalPrice"> {query.status === '00' ? totalPrice2(data) : totalPrice(data)}원</div>
            </div>

          </div>
          {
            query.status === '00' 
            ?
            <div className="row mb-2 p-0 mt-5">
              <div className="col-12 pl-0">
                <span className="btn btn-outline-secondary r_btnsize" onClick={() => {setBannerType('main');history.push('/');}}>돌아가기</span>
              </div>
            </div>
            :
            <div className="row mb-2 p-0 mt-5">
              <div className="col-6 pl-0">
                <span className="btn btn-outline-secondary r_btnsize" onClick={() => history.goBack()}>취소</span>
              </div>
              <div className="col-6 pr-0">
                <MakeBtn data={data} sigongSeq={sigongSeq} u_id={u_id}/>
              </div>
            </div>
          }
          
        </div>

      </Container>

    </>

  );
}





export default New_Cart;
